import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Container } from '@mui/material';
import AffiliationAdresse from './AffiliationAdresse';
import LegrandAppBar from './LegrandAppBar';

const AdressesScreenLegrand: React.FC = () => {
  const [user, setUser] = useState<any>(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem('user_legrand');
    if (!storedUser) {
      navigate('/');
      return;
    }
    setUser(JSON.parse(storedUser));
  }, [navigate]);

  return (
    <Box sx={{ flexGrow: 1 }}>
      <LegrandAppBar title="LEGRAND - Gestion des Adresses" username={user?.username} />

      <Container maxWidth={false} sx={{ mt: 2, px: 2 }}>
        <AffiliationAdresse />
      </Container>
    </Box>
  );
};

export default AdressesScreenLegrand;
